import { render, staticRenderFns } from "./layout-business.vue?vue&type=template&id=0a2b66d4&"
import script from "./layout-business.vue?vue&type=script&lang=js&"
export * from "./layout-business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports